import {baseRequestService} from "../base.ts";
import {EventRequestVatrusPost} from "../../types/domain.ts";

export const eventsEventIdRequestVatrusPost = (eventId: string, data: EventRequestVatrusPost) => baseRequestService({
    url: `/events/${eventId}/request_vatrus`,
    method: 'POST',
    data
})